if (typeof BeforeAfter !== "function") {
	class BeforeAfter extends HTMLElement {

		constructor() {

			super();
			this._prefix = window.KT_PREFIX || '';	

			this.container = this.querySelector(`.${this._prefix}before-after`);
			this.slider = this.querySelector(`.${this._prefix}before-after__slider`);

			this._beforeLabel = this.slider.dataset.beforeLabel || 'before';
			this._afterLabel = this.slider.dataset.afterLabel || 'after';

			const updatePosition = (value) => {
				this.container.style.setProperty('--position', `${value}%`);
				this.#announce(value);
			};

			this.slider.addEventListener("input", (e) => updatePosition(e.target.value));
			this.slider.addEventListener("change", (e) => updatePosition(e.target.value));

			if ( this.classList.contains(`${this._prefix}invert-layout`) ) {

				this.originalLayout = this.dataset.layout;

				this.RESIZE_WATCHER = debounce(()=>{
					const afterContent = window.getComputedStyle(this,':after').content;
					if ( afterContent.includes('invert-layout') && this.dataset.layout === this.originalLayout ) {
						this.#invertLayout();
					} else if ( ! afterContent.includes('invert-layout') && this.dataset.layout !== this.originalLayout )  {
						this.#invertLayout();
					}
				}, 100);
				window.addEventListener('resize', this.RESIZE_WATCHER);
				this.RESIZE_WATCHER();

			}

		}

		#announce(value) {
			const before = Math.round(value);
			const after = 100 - before;
			this.slider.setAttribute('aria-valuetext', `${before}% ${this._beforeLabel} / ${after}% ${this._afterLabel}`);
		}

		disconnectedCallback() {
			if ( this.RESIZE_WATCHER ) {
				window.removeEventListener('resize', this.RESIZE_WATCHER);
			}
		}

		#invertLayout() {
			this.dataset.layout = this.dataset.layout === 'vertical' ? 'horizontal' : 'vertical';
			this.setAttribute('data-layout', this.dataset.layout);
			this.querySelector('input[type="range"]').setAttribute('orient', this.dataset.layout);
		}

	}

	if (typeof customElements.get("before-after") == "undefined") {
		customElements.define("before-after", BeforeAfter);
	}
	
}